import React, { useEffect, useState } from "react";
import WorldMap from "react-svg-worldmap";

const ToppersReport = ({ toppersReportData }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    if (toppersReportData?.length > 0) {
      setData(toppersReportData);
    } else {
      setData([]);
    }
  }, [toppersReportData]);

  return (
    <div className="col-md-4 col-sm-12 d-flex">
      <div className="box shadow p-4 rounded cardBox text-light w-100 d-flex flex-column">
        <h5 className="text-center fw-bold mb-3">Toppers Reports</h5>
        <div className="flex-grow-1 d-flex align-items-end">
          {data?.length > 0 && (
            <WorldMap
              color="#00cdf2"
              value-suffix="Users"
              size="md"
              data={data}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ToppersReport;
